import { useLocation } from '@reach/router';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const useAutoScrollMultiple = ({
  open,
  setOpen,
  accordionKeys,
}: {
  open: string[];
  setOpen: Dispatch<SetStateAction<string[]>>;
  accordionKeys: string[];
}) => {
  const [isRemoving, setIsRemoving] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!open || open.length === 0) {
      setIsRemoving(false);
      return;
    }
    if (isRemoving) {
      setIsRemoving(false);
      return;
    }
    setTimeout(() => {
      window.location.hash = `#${open[open.length - 1]}`;
    }, 1);
    // eslint-disable-next-line
  }, [open]);

  useEffect(() => {
    if (!location.hash) return;
    const hash = location.hash.replace('#', '');
    const newActiveKey = accordionKeys.find(key => key === hash);

    if (newActiveKey && open.length === 0) {
      setOpen([newActiveKey]);
    }
    // eslint-disable-next-line
  }, [location.hash]);

  return { isRemoving, setIsRemoving };
};
